import {
  ProductImageBlock,
  ProductImageBlockProps,
  useCaseType,
} from '@rimactechnology/rimac-ui-lib';

import { ProductImageBlockFragment } from '@/api';
import { ORIENTATION_TYPE } from '@/constants/constants';
import getCdlPublicId from '@/hooks/useCdlPublicId';

interface EnhancedProductImageBlockProps {
  productImageBlock?: ProductImageBlockFragment | null;
  orientation?: ORIENTATION_TYPE;
  parentIndex: number;
}

const orientationByCmsValue: Record<string, ORIENTATION_TYPE> = {
  image_left: ORIENTATION_TYPE.IMAGE_LEFT,
  image_right: ORIENTATION_TYPE.IMAGE_RIGHT,
};

export default function EnhancedProductImageBlock({
  productImageBlock,
  orientation = ORIENTATION_TYPE.IMAGE_LEFT,
  parentIndex = 1,
}: EnhancedProductImageBlockProps) {
  // The CMS value wins when an editor sets one; otherwise blocks keep
  // alternating sides based on their position, as they did before.
  const cmsOrientation = productImageBlock?.orientation
    ? orientationByCmsValue[productImageBlock.orientation]
    : undefined;

  const productImageBlockProps: ProductImageBlockProps = {
    orientation: cmsOrientation || orientation,
    parentIndex: parentIndex,
    title: productImageBlock?.title || '',
    subtitle: productImageBlock?.subtitle || '',
    galleryExtraText: productImageBlock?.galleryExtraText || '',
    extraText: productImageBlock?.extraText || '',
    anchor: productImageBlock?.anchor || undefined,
    paragraphs: [
      productImageBlock?.paragraph || '',
      productImageBlock?.paragraphTwo || '',
    ],
    images: [
      {
        imgSrc:
          getCdlPublicId(
            productImageBlock?.image?.img_desktop.data?.attributes?.url,
          ) || 'rimac/ui-lib/sample',
        imgSrcMobile:
          getCdlPublicId(
            productImageBlock?.image?.img_mobile?.data?.attributes?.url,
          ) || 'rimac/ui-lib/sample',
        alt: productImageBlock?.image?.alt || '',
        blurHash:
          productImageBlock?.image?.img_desktop.data?.attributes?.blurhash ||
          'LAS?DV%M_3D%t7fQofj[~qM{4n-;',
      },
    ],
    button: {
      label: productImageBlock?.button?.label || '',
      path: productImageBlock?.button?.path || '',
      useCase: (productImageBlock?.buttonUseCase || 'group') as useCaseType,
    },
    largeSpecsTable: (productImageBlock?.largeSpec || []).map((spec) => ({
      label: spec?.label || '',
      value: spec?.value || '',
    })),
  };

  let wrapperClassName: string | undefined;
  if (productImageBlock?.buttonUseCase === 'energy') {
    wrapperClassName = 'rimac-energy-product-block';
  } else if (productImageBlock?.subtitle?.toLowerCase() === 'verne') {
    wrapperClassName = 'verne-product-block';
  }

  return (
    <div className={wrapperClassName}>
      <ProductImageBlock {...productImageBlockProps} />
    </div>
  );
}
